import { ValidatedResource } from '../core/validated-resource';

export class OrderTimeInfo extends ValidatedResource {
  asapNote: string;
}
